import { ApiClient } from "zoox-infra";
import moment from "moment";

export default class GuestControlService {
  constructor() {
    this.apiClient = new ApiClient();
  }

  async getExternalAccess(companyId, personId, identifier) {
    const { data } = await this.apiClient.get(
      `external-access?companyId=${companyId}&personId=${personId}&identifier=${identifier}`
    );

    if (data.length === 0) {
      return null;
    }

    return data[0];
  }

  async createExternalAccess(
    companyId,
    personId,
    identifier,
    name,
    lastName,
    roomName,
    checkoutDate,
    isWalkIn = false
  ) {
    let expiration;
    if (checkoutDate === null) {
      expiration = moment()
        .add(30, "minute")
        .utc()
        .toISOString();
    } else {
      expiration = moment(checkoutDate, "YYYY-MM-DD HH:mm:ss")
        .utc()
        .set({
          hour: 23,
          minute: 59,
          second: 59
        })
        .toISOString();
    }

    return this.apiClient.post("external-access", {
      companyId,
      personId,
      identifier,
      name,
      lastName,
      roomName,
      expiration,
      isWalkIn
    });
  }

  async getUrl() {
    return this.apiClient.get("guest-control/url");
  }

  updatePersonFnrh(fnrhId, mobileCityCode, mobilePhoneNumber) {
    return this.apiClient.put(`external-access/fnrh/${fnrhId}`, {
      mobileCityCode,
      mobilePhoneNumber
    });
  }

  savePersonWppOptin(companyId, personId, isChecked) {
    this.apiClient.put(`open/term-accept/5/${companyId}/${personId}`, {
      is_checked: isChecked
    });
  }
}
